export default __webpack_public_path__ + "volume_off-960-d3d1d44f21b102ea51467fff7bc977fd.png";